module.exports = __webpack_public_path__ + "static/media/star_with_bg.6f1027d2.svg";